export default __webpack_public_path__ + "static/media/Blooded Helm of the Four Winds.3c3896ae.jpg";